import { JiraPlus } from "@/components/signup/collection-opt-in";
import { hasJiraPlusPaidParam } from "@/components/signup/utils";
import { useLoggedIn } from "@/components/user-context";
import { useLocalizedHref } from "@/libraries/web-framework";
import { experiments, useExperiment, EnrollmentType } from "@/utils/experiment";
import { useLocation } from "@/utils/location-provider";

export const JiraSoftwareFreePage = () => {
    const isLoggedIn = useLoggedIn();
    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);
    const jiraPlusExperimentPaid = useExperiment(
        experiments.twcg1444JiraPlusOptInPaid
    );
    const signupPath = useLocalizedHref("/try/cloud/signup");
    const location = useLocation();
    const isPaidExperience = hasJiraPlusPaidParam(location);
    const experiment = isPaidExperience
        ? jiraPlusExperimentPaid
        : jiraPlusExperiment;

    if (isLoggedIn && experiment.type === EnrollmentType.ENROLLED) {
        experiment.fireExposure();
        if (experiment.value) {
            return <JiraPlus />;
        }
    }

    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search) || {};
    const templateId = queryParameters.get("templateId") ?? "";
    const jiraProductTourSignupType =
        queryParameters.get("jiraProductTourSignupType") ?? "";
    const signupParameters = new URLSearchParams({
        bundle: "jira-software",
        edition: "free",
        skipBundles: "true"
    });
    if (templateId) {
        signupParameters.append("templateId", templateId);
    }
    if (jiraProductTourSignupType) {
        signupParameters.append(
            "jiraProductTourSignupType",
            jiraProductTourSignupType
        );
    }
    if (typeof window !== "undefined") {
        window.location.assign(`${signupPath}?${signupParameters}`);
    }
    return null;
};
